import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { supabase } from './supabaseClient';
import Navbar from './components/helpers/Navbar';
import Login from './components/pages/Login';
import Dashboard from './components/pages/Dashboard';
import WebsitesAdminPage from './components/pages/WebsitesAdmin';
import ClientsPage from './components/pages/ClientsPage';
import InvoicesPage from './components/pages/InvoicesPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import HtmlToPdfConverter from './components/pages/HtmlToPdfConverter';

// Componentă pentru rute protejate
// Aceasta verifică dacă există o sesiune activă. Dacă nu, redirecționează la /login.
const ProtectedRoute = ({ children, session }) => {
  if (!session) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Componenta principală a aplicației
function AppWrapper() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  
  useEffect(() => {
    // Verifică starea de autentificare inițială
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    // Ascultă modificările stării de autentificare (login/logout)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });

    // Curăță abonamentul la unmount
    return () => subscription.unsubscribe();
  }, []);

  // Logica pentru afișarea Navbar-ului: se afișează doar dacă există o sesiune activă
  // și calea curentă nu este /login.
  const showNavbar = session && location.pathname !== '/login';

  // Afișează un spinner de încărcare în timp ce verifică starea de autentificare
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      {showNavbar && <Navbar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        
        {/* Rutele protejate sunt încapsulate în ProtectedRoute */}
        <Route path="/dashboard" element={
          <ProtectedRoute session={session}>
            <Dashboard />
          </ProtectedRoute>
        } />
        <Route path="/websites" element={
          <ProtectedRoute session={session}>
            <WebsitesAdminPage />
          </ProtectedRoute>
        } />
        <Route path="/clients" element={
          <ProtectedRoute session={session}>
            <ClientsPage />
          </ProtectedRoute>
        } />
        <Route path="/invoices" element={
          <ProtectedRoute session={session}>
            <InvoicesPage />
          </ProtectedRoute>
        } />
        <Route path="/convert" element={
          <ProtectedRoute session={session}>
            <HtmlToPdfConverter />
          </ProtectedRoute>
        } />
        
        {/* Orice altă rută va redirecționa la login dacă nu ești autentificat */}
        <Route path="*" element={session ? <Dashboard /> : <Navigate to="/login" />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}

export default App;
